import { z } from 'zod'

// query strings arrive as text; each param is coerced and bounded here so a malformed value is a
// 400 instead of a NaN reaching the service (a 500) or a huge month count loading the whole history

const monthCount = (defaultValue: number) =>
  z.coerce.number().int().min(1).max(60).default(defaultValue)

const periodParam = z.enum(['month', 'week', 'quarter', 'year']).default('month')

// current-expenses / current-incomes: the period and how many rows to render
export const currentTransactionsQuerySchema = z.object({
  period: periodParam,
  limit: z.coerce.number().int().min(1).max(50).default(5),
})
export type CurrentTransactionsQueryDto = z.infer<typeof currentTransactionsQuerySchema>

export const incomeExpenseChartQuerySchema = z.object({
  historyMonths: monthCount(12),
  projectionMonths: monthCount(12),
})
export type IncomeExpenseChartQueryDto = z.infer<typeof incomeExpenseChartQuerySchema>

export const monthsLeftQuerySchema = z.object({
  // repeated `accountIds=…` keys parse as an array, a single one as a string; omitted means every
  // live account
  accountIds: z
    .preprocess((value) => (typeof value === 'string' ? [value] : value), z.array(z.guid()))
    .optional(),
  historyMonths: monthCount(6),
  projectionMonths: monthCount(12),
  excludeActiveIncome: z
    .enum(['true', 'false'])
    .transform((value) => value === 'true')
    .default(false),
})
export type MonthsLeftQueryDto = z.infer<typeof monthsLeftQuerySchema>
